var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { validatorTypes } from "../Form/validatorTypes";
import { componentTypes } from "../Form/componentTypes";
import i18n from "i18next";
import pickBy from "lodash/pickBy";
import assign from "lodash/assign";
import { getApiDateObject } from "../../helpers/date";
var getValidators = function (attributes) {
    var validators = [];
    if (!!attributes.is_required) {
        validators.push(getRequiredValidator());
    }
    switch (attributes.field_type_name) {
        case "email_confirmed":
            validators.push(getConfirmEmailValidator(attributes.name));
        // case "date":
        //     validators.push(getDateValidator(attributes.title))
    }
    return validators;
};
export var normalizeField = function (field, extra) {
    var _a;
    if (extra === void 0) { extra = {}; }
    var _b = extra, options = _b.options, _c = _b.prefix, namePrefix = _c === void 0 ? '' : _c, name = _b.name, extraProps = __rest(_b, ["options", "prefix", "name"]);
    var _d = field, related = _d.related, _e = _d.presented, presented = _e === void 0 ? {} : _e, attributes = __rest(_d, ["related", "presented"]);
    var fieldName = [name || attributes.column_name || attributes.name];
    var disableValidation = extraProps.disableValidation, getDynamicValue = extraProps.getDynamicValue, otherExtraProps = __rest(extraProps, ["disableValidation", "getDynamicValue"]);
    if (namePrefix)
        fieldName.unshift(namePrefix);
    var fieldTypes = (_a = {
            select: componentTypes.SELECT,
            salutation: componentTypes.SELECT,
            country: componentTypes.SELECT,
            textarea: componentTypes.TEXTAREA,
            yesnoradio: componentTypes.SWITCH,
            switch: componentTypes.SWITCH
        },
        _a[componentTypes.TIME_SLOT] = componentTypes.TIME_SLOT,
        _a[componentTypes.SEARCH_N_SELECT] = componentTypes.SEARCH_N_SELECT,
        _a[componentTypes.PRICE_SELECT] = componentTypes.PRICE_SELECT,
        _a[componentTypes.PAYMENT_GATEWAY_RADIO] = componentTypes.PAYMENT_GATEWAY_RADIO,
        _a);
    var component = fieldTypes[attributes.field_type_name] || componentTypes.TEXT_FIELD;
    var children = attributes.children || presented.body;
    var type = fieldTypes[attributes.field_type_name] ? null : attributes.field_type_name;
    if (type === "date" || type === "birthday") {
        otherExtraProps.getDynamicValue = setDynamicDate(fieldName.join('.'), getDynamicValue);
        attributes.placeholder = i18n.t("date.date_input_format_placeholder");
        fieldName.push("date");
    }
    if (type === "time") {
        otherExtraProps.getDynamicValue = setDynamicTime(fieldName.join('.'));
        attributes.placeholder = "00:00";
        fieldName.push("time");
    }
    if (type === "email_confirmed") {
        otherExtraProps.disableCopyPaste = true;
        otherExtraProps.type = "email";
        disableValidation = false;
    }
    return pickBy(__assign({ component: component,
        options: options,
        type: type, getDynamicValue: otherExtraProps.getDynamicValue || getDynamicValue, getOptions: attributes.getOptions, checked: attributes.checked, children: children, disabled: !!attributes.is_disabled || false, name: fieldName.join('.'), placeholder: attributes.placeholder, label: attributes.title, required: !disableValidation && !!attributes.is_required, validate: disableValidation ? [] : getValidators(__assign(__assign({}, attributes), { name: fieldName.join('.') })) }, otherExtraProps), function (x) { return x !== undefined; });
};
export var getRequiredValidator = function () {
    return { type: validatorTypes.REQUIRED };
};
export var getEmailValidator = function () {
    return {
        type: validatorTypes.PATTERN,
        pattern: /^\w+[a-z0-9._-]\w+@\w+[a-z0-9.-]+\w+.[a-z]{2,}$/i,
        message: i18n.t('errors.invalid_email')
    };
};
export var getConfirmEmailValidator = function (name) {
    return { type: validatorTypes.CONFIRM_EMAIL };
};
export var getDateValidator = function (name) {
    return {
        type: validatorTypes.DATE,
        message: i18n.t('errors.invalid_date', { name: name })
    };
};
var setDynamicDate = function (groupName, getDynamicDate) { return function (target, state) {
    return [{
            key: groupName,
            value: target.value ? getApiDateObject(target.value, "date") : undefined
        }]
        .concat(getDynamicDate === null || getDynamicDate === void 0 ? void 0 : getDynamicDate(target, state))
        .filter(Boolean);
}; };
var setDynamicTime = function (groupName) { return function (target) {
    return {
        key: groupName,
        value: target.value ? assign({}, {
            time: target.value,
            "timezone_type": 3,
            "timezone": "Europe/Berlin"
        }) : undefined
    };
}; };
